export default __webpack_public_path__ + "static/media/6.027338a5.jpg";